import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; 
export default function LoadingMainCard({ cards }) {
  return (
    <div className='row m-auto'>
      <p className='mb-4' style={{ fontWeight: "200", fontSize: "1.5rem" }}>Latest Documents</p>
      {Array(cards).fill(0).map((_, index) => (
        <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
          <div className='px-3 h-100 d-flex flex-column documents' style={{ border: '1px solid var(--hairline)', borderRadius: "25px" }}>
            <div className='d-flex mt-3'>
              <div>
                <p className={`policeName`}><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={250} height={10}/></p>
                <p><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={250} height={10}/></p>
                <p className=''><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={250} height={10}/></p>
                <p className=''><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={250} height={10}/></p>
              </div>
            </div>
          </div>
        </div>
      ))}

    </div>
  );
}

